var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { Drawer, Tooltip, ListItem, withStyles, AccordionSummary, AccordionDetails, } from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { NavLink } from 'react-router-dom';
import logo from 'asset/inc/img/global/logo.png';
import { StyledExpansionPanel, dToolTipProps } from './SidebarList';
var MenuShowStyle = require('./MenuShowStyle.module.css');
var SidebarListStyle = require('./SidebarListStyle.module.css');
var StyledExpansionPanelSummary = withStyles({
    root: {
        padding: '0 12px',
        margin: 0,
        color: 'white',
        borderBottom: '1px solid rgba(255, 255, 255, 0.15)',
        fontSize: '1.4em',
        '&:hover': { color: '#0086da' },
        '&$expanded': { minHeight: 'initial' },
    },
    content: {
        margin: '0px',
        '&$expanded': { margin: '0px' },
    },
    expanded: { minHeight: 'initial' },
})(AccordionSummary);
var StyledExpansionPanelSummaryTwo = withStyles({
    root: {
        padding: '0 12px',
        margin: 0,
        color: 'white',
        borderBottom: '1px solid rgba(255, 255, 255, 0.15)',
        backgroundColor: '#4a596f',
        // fontSize: "1.1em",
        '&:hover': { color: '#0086da' },
        '&$expanded': { minHeight: 'initial' },
    },
    content: {
        margin: '0px',
        '&$expanded': { margin: '0px' },
    },
    expanded: { minHeight: 'initial' },
})(AccordionSummary);
var StyledExpansionPanelDetails = withStyles({
    root: {
        display: 'block',
        padding: '0px',
        borderRadius: '0px',
        // fontSize: "1.1em",
        '&:hover': {
            color: 'red',
        },
    },
})(AccordionDetails);
var StyledListItem = withStyles({
    root: {
        color: 'white',
        textDecoration: 'none',
        padding: '12px',
        justifyContent: 'center',
        borderBottom: '1px solid rgba(255, 255, 255, 0.15)',
        backgroundColor: '#4a596f',
        // fontSize: "1.1em",
        '&:hover': { color: '#0086da' },
        '&$selected': { backgroundColor: 'rgb(0, 134, 218)' },
    },
    selected: {
        backgroundColor: 'rgb(0, 134, 218)',
        '&:hover': {
            color: 'white',
            fontWeight: 'bold',
            backgroundColor: 'rgb(0, 134, 218) !important',
        },
    },
})(ListItem);
var StyledListItemTwo = withStyles({
    root: {
        color: 'white',
        textDecoration: 'none',
        padding: '6px 12px',
        justifyContent: 'center',
        borderBottom: '1px solid rgba(255, 255, 255, 0.15)',
        backgroundColor: '#647792',
        // fontSize: "1.1em",
        '&:hover': { color: '#0086da' },
        '&$selected': { backgroundColor: 'rgb(0, 134, 218)' },
    },
    selected: {
        backgroundColor: 'rgb(0, 134, 218)',
        '&:hover': {
            color: 'white',
            fontWeight: 'bold',
            backgroundColor: 'rgb(0, 134, 218) !important',
        },
    },
})(ListItem);
var MobileMenuSidebar = function (props) { return (React.createElement(Drawer, { open: props.sidebarOpen, onClose: props.handleDrawerClose, PaperProps: {
        style: { backgroundColor: '#3d4b60' },
    } },
    React.createElement("div", { className: "header", style: { justifyContent: 'center' } },
        React.createElement("img", { width: "85%", src: logo, alt: "" })),
    props.userMenuLayoutData.map(function (prop) { return (React.createElement(StyledExpansionPanel, { expanded: props.mobileMenuExpanded, onChange: props.handleMobileChange(), key: prop.menuId },
        React.createElement(StyledExpansionPanelSummary, { expandIcon: React.createElement(ExpandMoreIcon, { style: { color: 'white' } }) }, prop.taskName),
        React.createElement(StyledExpansionPanelDetails, null, prop.children &&
            prop.children.map(function (pro) {
                return pro.children != null ? (React.createElement(StyledExpansionPanel, { key: pro.taskId, expanded: props.mobileMenuExpanded, onChange: props.handleMobileChange() },
                    React.createElement(StyledExpansionPanelSummaryTwo, { expandIcon: React.createElement(ExpandMoreIcon, { style: { color: 'white' } }) }, pro.taskName),
                    React.createElement(StyledExpansionPanelDetails, null, pro.children.map(function (propss) {
                        return propss.isExternalUrl === 'N' ? (React.createElement(NavLink, { to: propss.menuUrl || '#', activeClassName: "active", key: propss.taskId, className: SidebarListStyle.item },
                            React.createElement(Tooltip, __assign({}, dToolTipProps(propss.taskId)),
                                React.createElement(StyledListItemTwo, { button: true, selected: props.activeTaskId === propss.taskId, onClick: props.handleDrawerClick(propss.taskId, propss.taskName) }, propss.taskName)))) : (React.createElement("a", { target: "_blank", rel: "noopener noreferrer", href: pro.menuUrl, key: pro.taskId, className: MenuShowStyle.item },
                            React.createElement(ListItem, { button: true }, propss.taskName)));
                    })))) : pro.isExternalUrl === 'N' ? (React.createElement(NavLink, { to: pro.menuUrl || '#', activeClassName: "active", key: pro.taskId, className: SidebarListStyle.item },
                    React.createElement(Tooltip, __assign({}, dToolTipProps(pro.taskId)),
                        React.createElement(StyledListItem, { button: true, selected: props.activeTaskId === pro.taskId, onClick: props.handleDrawerClick(pro.taskId, pro.taskName) }, pro.taskName)))) : (React.createElement("a", { target: "_blank", rel: "noopener noreferrer", href: pro.menuUrl, key: pro.taskId, className: MenuShowStyle.item },
                    React.createElement(Tooltip, __assign({}, dToolTipProps(pro.taskId)),
                        React.createElement(StyledListItem, { button: true, selected: props.activeTaskId === pro.taskId, onClick: props.handleDrawerClick(pro.taskId, pro.taskName) }, pro.taskName))));
            })))); }))); };
export default MobileMenuSidebar;
